import React from 'react'

import {
  FieldBaseLayout,
  FieldBaseLabel,
  FieldBaseError,
  FieldBaseDescription,
} from '../components'
import type { IFieldLayoutProps } from '../types'

interface IBaseFieldLayoutProps extends IFieldLayoutProps {
  Component?: React.ComponentType<IFieldLayoutProps>
}

const FieldLayout: React.FC<IBaseFieldLayoutProps> = ({ Component, children, ...props }) => {
  const { layout = 'horizontal' } = props
  const isRow = layout === 'horizontal' || layout === 'toolbar'
  const isColumn = layout === 'vertical'

  if (Component) {
    return <Component {...props}>{children}</Component>
  }

  return (
    <>
      <FieldBaseLayout {...props}>
        <FieldBaseLabel {...props} />
        {isColumn && <FieldBaseDescription {...props} />}
        {children}
        <FieldBaseError {...props} />
      </FieldBaseLayout>
      {isRow && <FieldBaseDescription {...props} />}
    </>
  )
}

export default FieldLayout
